import * as React from 'react';
import { cn } from '@/lib/utils';
import {
  ClockFading,
  LoaderCircle,
  CircleCheck,
  CircleX,
} from 'lucide-react';
import type { ProfileStatus } from '../types';

export function StatusPill({
  status,
  label,
}: {
  status: ProfileStatus;
  /** Overrides the default status label (e.g. meeting summary "Анализ завершен"). */
  label?: string;
}) {
  if (!status) return null;

  const meta: Record<
    ProfileStatus,
    {
      icon: React.ReactNode;
      label: string;
      className: string;
    }
  > = {
    not_started: {
      icon: (
        <ClockFading
          color={'var(--color-neutral-text-500)'}
          size="16"
          className="p-[1.33px]"
          strokeWidth={2.5}
        />
      ),
      label: 'Не начато',
      className: 'text-neutral-text-500 bg-neutral-border-300',
    },
    processing: {
      icon: (
        <LoaderCircle
          color={'var(--color-state-warning)'}
          size="16"
          className="p-[1.33px] animate-spin"
          strokeWidth={2.5}
        />
      ),
      label: 'В обработке',
      className: 'text-state-warning bg-state-warning-light',
    },
    success: {
      icon: (
        <CircleCheck
          color={'var(--color-state-positive)'}
          size="16"
          className="p-[1.33px]"
          strokeWidth={2.5}
        />
      ),
      label: 'Успешно',
      className: 'text-state-positive bg-state-positive-light',
    },
    error: {
      icon: (
        <CircleX
          color={'var(--color-state-negative)'}
          size="16"
          className="p-[1.33px]"
          strokeWidth={2.5}
        />
      ),
      label: 'Ошибка',
      className: 'text-state-negative bg-state-negative-light',
    },
  };
  return (
    <div
      className={cn(
        'text-caption inline-flex gap-1 shrink-0 items-center rounded-full ml-1 pl-0.5 py-0.5 pr-1',
        meta[status].className
      )}
    >
      {meta[status].icon}
      {label ?? meta[status].label}
    </div>
  );
}
